interface PrivacyPolicyProps {
  onBack?: () => void;
}

const WHATSAPP_URL = "https://wa.me/972526868888";

export function PrivacyPolicy({ onBack }: PrivacyPolicyProps) {
  return (
    <div
      dir="rtl"
      className="px-5 pt-5 pb-12 flex flex-col gap-6"
      style={{ color: "var(--parchment-soft)" }}
    >
      <div>
        {onBack && (
          <button
            onClick={onBack}
            className="mb-4 flex items-center gap-1.5 text-sm"
            style={{ color: "var(--gold-300)", opacity: 0.85 }}
          >
            <span className="text-lg leading-none">→</span> חזרה
          </button>
        )}
        <p
          style={{
            fontFamily: "'Heebo', sans-serif",
            fontSize: 11,
            letterSpacing: "0.25em",
            textTransform: "uppercase",
            color: "var(--gold-400)",
            opacity: 0.9,
          }}
        >
          משפטי
        </p>
        <h1
          className="font-serif"
          style={{
            fontSize: 22,
            fontWeight: 700,
            color: "var(--parchment-soft)",
            marginTop: 4,
          }}
        >
          מדיניות פרטיות
        </h1>
      </div>

      <LegalSection title="מבוא">
        <p>
          האתר ניגונים (להלן: "המפעיל"). המפעיל מחויב לשמירה על פרטיות
          המשתמשים ופועל בהתאם לחוק הגנת הפרטיות, תקנות אבטחת מידע וחוק
          הספאם. מדיניות פרטיות זו מסבירה אילו סוגי מידע אנו אוספים, איך אנו
          משתמשים בו, כיצד אנו שומרים עליו וזכויות המשתמשים.
        </p>
      </LegalSection>

      <LegalSection title="מידע הנאסף">
        <p>
          המידע הנאסף מהמשתמש כולל את שמו המלא, כתובת הדוא"ל ותמונה מחשבון
          גוגל, כאשר ההרשמה באתר מתבצעת אך ורק באמצעות חשבון גוגל. בנוסף,
          האתר אוסף מידע טכני אוטומטי כגון כתובת IP, סוג הדפדפן, מערכת
          ההפעלה, עמודים שנצפו, זמן שהייה באתר ופעולות שבוצעו. המידע הזה
          נאסף באמצעות קבצי Cookie ושירותי ניתוח לצורך תפעול האתר, שיפור
          חוויית המשתמש והצגת פרסומות מותאמות אישית.
        </p>
      </LegalSection>

      <LegalSection title="שימוש במידע">
        <p>
          המידע משמש לניהול קשר עם משתמשים, שליחת ניוזלטרים והודעות שיווקיות,
          ניתוח סטטיסטי ואנונימי, התאמת תכנים והצעת פרסומות מותאמות אישית,
          וכן לאכיפת תנאי השימוש של האתר ולמניעת שימוש בלתי חוקי.
        </p>
      </LegalSection>

      <LegalSection title="שמירת מידע ואבטחה">
        <p>
          המידע נשמר במאגרי מידע מאובטחים בישראל או בחו"ל, והמפעיל נוקט
          באמצעי אבטחה סבירים כגון בקרת גישה. עם זאת, אין באפשרותו להבטיח
          הגנה מוחלטת מפני חדירה או גניבה, והמשתמש מצהיר כי הוא מודע לכך.
        </p>
      </LegalSection>

      <LegalSection title="שיתוף מידע עם צדדים שלישיים">
        <p>
          המידע יועבר לצדדים שלישיים רק אם המשתמש מסכים לכך, לצורך תפעול
          האתר או לפי דרישה חוקית. כל צד שלישי מחויב לשמירה על סודיות
          ואבטחת המידע.
        </p>
      </LegalSection>

      <LegalSection title="זכויות המשתמש">
        <p>
          האתר שומר על פרטיות המשתמשים ומידע שנאסף אינו מוצג או נגיש
          למשתמשים לצפייה או שינוי. המידע משמש אך ורק למטרות פנימיות של
          ניהול האתר, שיפור חוויית המשתמש ושליחת דיוורים בהתאם להסכמה שניתנה.
          למשתמש קיימת אפשרות להסיר את עצמו ממאגרי הדיוור והשיווק הישיר
          באמצעות{" "}
          <a
            href={WHATSAPP_URL}
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: "var(--gold-300)", textDecoration: "underline" }}
          >
            פנייה אלינו בוואטסאפ
          </a>
          .
        </p>
      </LegalSection>

      <LegalSection title="שינויים במדיניות">
        <p>
          המפעיל שומר לעצמו את הזכות לעדכן, לשנות או לבטל סעיפים במדיניות
          זו בכל עת. השימוש באתר לאחר עדכון מהווה הסכמה למדיניות החדשה.
        </p>
      </LegalSection>
    </div>
  );
}

function LegalSection({
  title,
  children,
}: {
  title: string;
  children: React.ReactNode;
}) {
  return (
    <div className="flex flex-col gap-2">
      <h2
        className="font-serif pb-2"
        style={{
          fontSize: 16,
          fontWeight: 700,
          color: "var(--gold-300)",
          borderBottom: "1px solid rgba(212,162,74,0.22)",
        }}
      >
        {title}
      </h2>
      <div
        className="leading-relaxed"
        style={{
          fontFamily: "'Heebo', sans-serif",
          fontSize: 13,
          color: "var(--text-secondary)",
          lineHeight: 1.7,
        }}
      >
        {children}
      </div>
    </div>
  );
}
